"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _constants = require("../constants");
var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));
var _MediaConnectionAwaiter = _interopRequireDefault(require("./MediaConnectionAwaiter"));
/* eslint-disable class-methods-use-this */
/**
 * @class MediaProperties
 */
var MediaProperties = exports.default = /*#__PURE__*/function () {
  /**
   * @param {Object} [options] -- to auto construct
   * @returns {MediaProperties}
   */
  function MediaProperties() {
    (0, _classCallCheck2.default)(this, MediaProperties);
    (0, _defineProperty2.default)(this, "audioStream", void 0);
    (0, _defineProperty2.default)(this, "mediaDirection", void 0);
    (0, _defineProperty2.default)(this, "mediaSettings", void 0);
    (0, _defineProperty2.default)(this, "webrtcMediaConnection", void 0);
    (0, _defineProperty2.default)(this, "remoteAudioStream", void 0);
    (0, _defineProperty2.default)(this, "remoteQualityLevel", void 0);
    (0, _defineProperty2.default)(this, "remoteShareStream", void 0);
    (0, _defineProperty2.default)(this, "remoteVideoStream", void 0);
    (0, _defineProperty2.default)(this, "shareVideoStream", void 0);
    (0, _defineProperty2.default)(this, "shareAudioStream", void 0);
    (0, _defineProperty2.default)(this, "videoDeviceId", void 0);
    (0, _defineProperty2.default)(this, "videoStream", void 0);
    (0, _defineProperty2.default)(this, "namespace", _constants.MEETINGS);
    this.webrtcMediaConnection = null;
    this.mediaDirection = {
      receiveAudio: false,
      receiveVideo: false,
      receiveShare: false,
      sendAudio: false,
      sendVideo: false,
      sendShare: false
    };
    this.videoStream = null;
    this.audioStream = null;
    this.shareVideoStream = null;
    this.shareAudioStream = null;
    this.remoteShareStream = undefined;
    this.remoteAudioStream = undefined;
    this.remoteVideoStream = undefined;
    this.remoteQualityLevel = _constants.QUALITY_LEVELS.HIGH;
    this.mediaSettings = {};
    this.videoDeviceId = null;
  }

  /**
   * Retrieves the preferred video input device
   * @returns {Object|null}
   */
  (0, _createClass2.default)(MediaProperties, [{
    key: "getVideoDeviceId",
    value: function getVideoDeviceId() {
      return this.videoDeviceId || null;
    }
  }, {
    key: "setMediaDirection",
    value: function setMediaDirection(mediaDirection) {
      this.mediaDirection = mediaDirection;
    }
  }, {
    key: "setMediaSettings",
    value: function setMediaSettings(type, values) {
      this.mediaSettings[type] = values;
    }
  }, {
    key: "setMediaPeerConnection",
    value: function setMediaPeerConnection(mediaPeerConnection) {
      this.webrtcMediaConnection = mediaPeerConnection;
    }
  }, {
    key: "setLocalVideoStream",
    value: function setLocalVideoStream(videoStream) {
      this.videoStream = videoStream;
    }
  }, {
    key: "setLocalAudioStream",
    value: function setLocalAudioStream(audioStream) {
      this.audioStream = audioStream;
    }
  }, {
    key: "setLocalShareVideoStream",
    value: function setLocalShareVideoStream(shareVideoStream) {
      this.shareVideoStream = shareVideoStream;
    }
  }, {
    key: "setLocalShareAudioStream",
    value: function setLocalShareAudioStream(shareAudioStream) {
      this.shareAudioStream = shareAudioStream;
    }
  }, {
    key: "setRemoteQualityLevel",
    value: function setRemoteQualityLevel(remoteQualityLevel) {
      this.remoteQualityLevel = remoteQualityLevel;
    }
  }, {
    key: "setRemoteShareStream",
    value: function setRemoteShareStream(remoteShareStream) {
      this.remoteShareStream = remoteShareStream;
    }

    /**
     * Sets the remote audio stream
     * @param {RemoteStream} remoteAudioStream RemoteStream to save
     * @returns {void}
     */
  }, {
    key: "setRemoteAudioStream",
    value: function setRemoteAudioStream(remoteAudioStream) {
      this.remoteAudioStream = remoteAudioStream;
    }

    /**
     * Sets the remote video stream
     * @param {RemoteStream} remoteVideoStream RemoteStream to save
     * @returns {void}
     */
  }, {
    key: "setRemoteVideoStream",
    value: function setRemoteVideoStream(remoteVideoStream) {
      this.remoteVideoStream = remoteVideoStream;
    }

    /**
     * Stores the preferred video input device
     * @param {string} deviceId Preferred video input device
     * @returns {void}
     */
  }, {
    key: "setVideoDeviceId",
    value: function setVideoDeviceId(deviceId) {
      this.videoDeviceId = deviceId;
    }
  }, {
    key: "unsetPeerConnection",
    value: function unsetPeerConnection() {
      this.webrtcMediaConnection = null;
    }

    /**
     * Removes both remote audio and video from class instance
     * @returns {void}
     */
  }, {
    key: "unsetRemoteMedia",
    value: function unsetRemoteMedia() {
      this.remoteAudioStream = null;
      this.remoteVideoStream = null;
    }
  }, {
    key: "unsetRemoteShareStream",
    value: function unsetRemoteShareStream() {
      this.remoteShareStream = null;
    }

    /**
     * Unsets all remote streams
     * @returns {void}
     */
  }, {
    key: "unsetRemoteStreams",
    value: function unsetRemoteStreams() {
      this.unsetRemoteMedia();
      this.unsetRemoteShareStream();
    }

    /**
     * Returns if we have at least one local share stream or not.
     * @returns {Boolean}
     */
  }, {
    key: "hasLocalShareStream",
    value: function hasLocalShareStream() {
      return !!(this.shareAudioStream || this.shareVideoStream);
    }

    /**
     * Waits for the webrtc media connection to be connected.
     *
     * @returns {Promise<void>}
     */
  }, {
    key: "waitForMediaConnectionConnected",
    value: function waitForMediaConnectionConnected() {
      var mediaConnectionAwaiter = new _MediaConnectionAwaiter.default({
        webrtcMediaConnection: this.webrtcMediaConnection
      });
      return mediaConnectionAwaiter.waitForMediaConnectionConnected();
    }

    /**
     * Returns ICE transport information:
     * - selectedCandidatePairChanges - number of times the selected candidate pair was changed, it should be at least 1 for successful connections
     *  it will be -1 if browser doesn't supply this information
     * - numTransports - number of transports (should be 1 if we're using bundle)
     *
     * @param {Array<any>} allStatsReports array of RTC stats reports
     * @returns {Object}
     */
  }, {
    key: "getTransportInfo",
    value: function getTransportInfo(allStatsReports) {
      var transports = allStatsReports.filter(function (report) {
        return report.type === 'transport';
      });
      if (transports.length > 1) {
        _loggerProxy.default.logger.warn("Media:properties#getSelectedCandidatePairChanges --> found more than 1 transport: ".concat(transports.length));
      }
      return {
        selectedCandidatePairChanges: transports.length > 0 && transports[0].selectedCandidatePairChanges !== undefined ? transports[0].selectedCandidatePairChanges : -1,
        numTransports: transports.length
      };
    }

    /**
     * Returns the type of a connection that has been established
     * It should be 'UDP' | 'TCP' | 'TURN-TLS' | 'TURN-TCP' | 'TURN-UDP' | 'unknown'
     *
     * If connection was not established, it returns 'unknown'
     *
     * @param {Array<any>} allStatsReports array of RTC stats reports
     * @returns {string}
     */
  }, {
    key: "getConnectionType",
    value: function getConnectionType(allStatsReports) {
      var successfulCandidatePairs = allStatsReports.filter(function (report) {
        var _report$state;
        return report.type === 'candidate-pair' && ((_report$state = report.state) === null || _report$state === void 0 ? void 0 : _report$state.toLowerCase()) === 'succeeded';
      });
      var foundConnectionType = 'unknown';

      // all of the successful pairs should have the same connection type, so just return the type for the first one
      successfulCandidatePairs.some(function (pair) {
        var localCandidate = allStatsReports.find(function (report) {
          return report.type === 'local-candidate' && report.id === pair.localCandidateId;
        });
        if (localCandidate === undefined) {
          _loggerProxy.default.logger.warn("Media:properties#getConnectionType --> failed to find local candidate \"".concat(pair.localCandidateId, "\" in getStats() results"));
          return false;
        }
        var connectionType;
        if (localCandidate.relayProtocol) {
          connectionType = "TURN-".concat(localCandidate.relayProtocol.toUpperCase());
        } else {
          var _localCandidate$proto;
          connectionType = (_localCandidate$proto = localCandidate.protocol) === null || _localCandidate$proto === void 0 ? void 0 : _localCandidate$proto.toUpperCase(); // it will be UDP or TCP
        }

        if (connectionType) {
          foundConnectionType = connectionType;
          return true;
        }
        _loggerProxy.default.logger.warn("Media:properties#getConnectionType --> missing localCandidate.protocol, candidateType=".concat(localCandidate.candidateType));
        return false;
      });
      if (foundConnectionType === 'unknown') {
        var candidatePairStates = allStatsReports.filter(function (report) {
          return report.type === 'candidate-pair';
        }).map(function (report) {
          return report.state;
        });
        _loggerProxy.default.logger.warn("Media:properties#getConnectionType --> all candidate pair states: ".concat((0, _stringify.default)(candidatePairStates)));
      }
      return foundConnectionType;
    }

    /**
     * Returns information about current webrtc media connection
     *
     * @returns {Promise<Object>}
     */
  }, {
    key: "getCurrentConnectionInfo",
    value: (function () {
      var _getCurrentConnectionInfo = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var allStatsReports, statsResult, connectionType, _this$getTransportInf, selectedCandidatePairChanges, numTransports;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              allStatsReports = [];
              _context.prev = 1;
              _context.next = 4;
              return this.webrtcMediaConnection.getStats();
            case 4:
              statsResult = _context.sent;
              statsResult.forEach(function (report) {
                return allStatsReports.push(report);
              });
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              _loggerProxy.default.logger.warn("Media:properties#getCurrentConnectionInfo --> getStats() failed: ".concat(_context.t0));
            case 11:
              connectionType = this.getConnectionType(allStatsReports);
              _this$getTransportInf = this.getTransportInfo(allStatsReports), selectedCandidatePairChanges = _this$getTransportInf.selectedCandidatePairChanges, numTransports = _this$getTransportInf.numTransports;
              return _context.abrupt("return", {
                connectionType: connectionType,
                selectedCandidatePairChanges: selectedCandidatePairChanges,
                numTransports: numTransports
              });
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 8]]);
      }));
      function getCurrentConnectionInfo() {
        return _getCurrentConnectionInfo.apply(this, arguments);
      }
      return getCurrentConnectionInfo;
    }())
  }]);
  return MediaProperties;
}();
//# sourceMappingURL=properties.js.map
